import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';

import { renderToast } from 'components/Informations/Toast/utils';

import { pdiIcons } from 'pages/PDI/utils';

import { convertSizeToMB } from 'utils/numberManipulations';

import { toastMessages } from './utils';
import * as S from './styles';

const FIleButton = forwardRef(
  (
    {
      fileType,
      currentValue,
      maxMBSize,
      labelText,
      inputName,
      handleChange,
      handleReset,
    },
    ref,
  ) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const [savedFile, setSavedFile] = useState('');
    const [fileName, setFileName] = useState('');

    const [toastVisibility, setToastVisibility] = useState(false);
    const [toastInfos, setToastInfos] = useState({});

    useEffect(() => {
      if (currentValue) {
        setSavedFile(currentValue);
        setFileName(currentValue);
      }
    }, [currentValue]);

    const onReset = () => {
      setSavedFile('');
      setFileName('');

      return [
        handleReset,
        setToastInfos(toastMessages('onRemove')),
        setToastVisibility(true),
      ];
    };

    const onChange = event => {
      const { files, value } = event.target;
      const currentFile = files[0];

      const { type, size, name } = currentFile;
      const extensionFile = type.split('/')[1];

      if (!files.length || !fileType || !maxMBSize) return setIsDisabled(true);

      if (
        extensionFile === fileType.toLowerCase() &&
        convertSizeToMB(size) < maxMBSize
      ) {
        setFileName(currentFile.name);
        setSavedFile(value);

        return [
          handleChange(currentFile, value),
          setToastInfos(toastMessages('onSuccess', name)),
          setToastVisibility(true),
        ];
      }

      if (extensionFile !== fileType) {
        onReset();

        return [
          setToastInfos(toastMessages('onFileError', fileType)),
          setToastVisibility(true),
        ];
      }

      if (convertSizeToMB(size) > maxMBSize) {
        return [
          setToastInfos(toastMessages('onSizeError', maxMBSize)),
          setToastVisibility(true),
        ];
      }

      return [
        setToastInfos(toastMessages('defaultError')),
        setToastVisibility(true),
      ];
    };

    const changeEvent = e => {
      onChange(e);
      handleChange(e);
    };

    return (
      <>
        {toastVisibility &&
          renderToast(
            toastInfos.type,
            toastInfos.message,
            toastInfos.closeTime,
            setToastVisibility,
          )}

        <S.Container>
          {savedFile ? (
            <S.HasFiles>
              <S.FileName title={fileName}>{fileName}</S.FileName>
              <S.ResetFiles onClick={onReset}>X</S.ResetFiles>
            </S.HasFiles>
          ) : (
            <S.Label htmlFor={inputName}>
              {pdiIcons('upload')}
              {labelText}
            </S.Label>
          )}
          <S.FileInput
            ref={ref}
            id={inputName}
            name={inputName}
            value={currentValue || savedFile}
            onChange={changeEvent}
            disabled={isDisabled}
          />
        </S.Container>
      </>
    );
  },
);

export default FIleButton;

FIleButton.defaultProps = {
  maxMBSize: 1,
  currentValue: null,
  labelText: 'Upload',
  handleChange: () => {},
  handleReset: () => {},
};

FIleButton.propTypes = {
  fileType: PropTypes.string.isRequired,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  maxMBSize: PropTypes.number,
  labelText: PropTypes.string,
  inputName: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  handleReset: PropTypes.func,
};

// refProp: PropTypes.oneOfType([
//   PropTypes.func,
//   PropTypes.shape({ current: PropTypes.instanceOf(Element) })
// ])
